"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delayUntill = void 0;
var _gsap = _interopRequireDefault(require("gsap"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * A delayed call connected to ticker. GSAP ticker!!!
 * this is a basic abstraction.
 * use instead of timeout
 * 
 * @param cb 
 * @param ms 
 * @returns 
 */
var delayUntill = exports.delayUntill = function delayUntill(cb, ms) {
  return _gsap["default"].delayedCall(ms, cb);
};
//# sourceMappingURL=delayUntill.js.map